//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[[0,"ClientId",1,0],[0,"Country",1,0],[0,"Locale",1,0],[0,"Session",1,0],[0,"Timeout",1,0],[0,"UserId",1,0]],[[["accessKey","secretKey","collaborationSpaceId","containerType","containerId","region"],"ZEUS",{},6,0],[["userName","sessionToken","group","role","httpUrl","fscUrl"],"TC",{},6,0],[[],"GetVersionInformation",{R_:{version:''}},0,0],[[],"Native",{},0,0],[["context"],"SetContext",{},1,0],[[],"Terminate",{},0,0],[[],"Heartbeat",{},0,0],[["className","properties"],"SetPropertyPolicy",{},2,0],[["className"],"ClearPropertyPolicy",{},1,0],[[],"ClearAllPropertyPolicies",{},0,0],[[],"GetStatistics",{R_:{statistics:''}},0,0],[["nLib"],"Hydrate",{R_:{libs:""}},0,0],[["token","accessKey","secretKey"],"RefreshZeusAccessKeys",{},3,0],[["errors"],"ConvertToWarning",{},1,0],[["className","tokens"],"RemoveSecretKeysFromLog",{},2,0],[["sku","auth"],"SetEntitlementCredential",{},2,0],[["seed"],"GetDownloadKey",{R_:{key:''}},1,0],[["key"],"Download",{},1,0],[["accessToken"],"UpdateAuthToken",{},1,0],[["accessToken"],"TCX",{},1,0],[["transactionId"],"SaveToWorkBench",{},1,0]],[]];
SPLM.AtlasSession = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AtlasSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AtlasSession.JaAtlasAtlascontext = class{
    constructor(collaborationSpaceId,containerId,containerType,folderId){
        this.collaborationSpaceId=collaborationSpaceId;this.containerId=containerId;this.containerType=containerType;this.folderId=folderId;}
    get Collaborationspaceid(){return this.collaborationSpaceId}
    set Collaborationspaceid(val){this.collaborationSpaceId = val}
    get Containerid(){return this.containerId}
    set Containerid(val){this.containerId = val}
    get Containertype(){return this.containerType}
    set Containertype(val){this.containerType = val}
    get Folderid(){return this.folderId}
    set Folderid(val){this.folderId = val}
};

SPLM.AtlasSession.AtlasVersionInformation = class{
    constructor(release,compatibleBaseRelease,buildNumber,groupBuild){
        this.release=release;this.compatibleBaseRelease=compatibleBaseRelease;this.buildNumber=buildNumber;this.groupBuild=groupBuild;}
    get Release(){return this.release}
    set Release(val){this.release = val}
    get Compatiblebaserelease(){return this.compatibleBaseRelease}
    set Compatiblebaserelease(val){this.compatibleBaseRelease = val}
    get Buildnumber(){return this.buildNumber}
    set Buildnumber(val){this.buildNumber = val}
    get Groupbuild(){return this.groupBuild}
    set Groupbuild(val){this.groupBuild = val}
};

export default SPLM;